import script from "./TemplateCardView.vue?vue&type=script&setup=true&lang=ts"
export * from "./TemplateCardView.vue?vue&type=script&setup=true&lang=ts"

import "./TemplateCardView.vue?vue&type=style&index=0&id=3efc34b4&scoped=true&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3efc34b4"]])

export default __exports__